/**
 * @author Vlad
 */
var dupBind = { data: '=' };
var DetailTableDuplCheckResultsController = (function () {
    function DetailTableDuplCheckResultsController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs, Dialog, _) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.Dialog = Dialog;
        this._ = _;
        this.tableName = 'Duplicate Check Results';
        this.stateList = [];
        this.stateListCopy = [];
        this.duplicateFoundProps = ["Yes", "No"].map(function (e) { return ({ abbrev: e }); });
        this.isVersion4AndMore = false;
        this.isVersion5AndMore = false;
        this.OPP_VERSION_5 = 5;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_3 = 3;
        this.isTableEditMode = false;
        this.comp = 'dc';
        this.socket.forward('eligibility.getDuplicateCheckResultsData', this.$scope);
        this.$scope.$on('socket:eligibility.getDuplicateCheckResultsData', function (event, data) {
            _this.tableHeader = data.header;
            _this.tableRows = data.rows;
            _this.tableBackendErrors = data.err;
            _this.isEditableList = _this.tableRows.map(function (e) { return false; });
            _this.version = data.version;
            _this.isVersion4AndMore = (data.version > _this.OPP_VERSION_3);
            _this.isVersion5AndMore = (data.version >= _this.OPP_VERSION_5);
            _this.checkIfRowFails();
            _this.checkTableErrors();
        });
        this.socket.forward('topic.update.partial', this.$scope);
        this.$scope.$on('socket:topic.update.partial', function (event, data) {
            _this.updateDealRegProductGroupData();
        });
    }
    DetailTableDuplCheckResultsController.prototype.$onInit = function () {
        this.getDuplicateCheckResultsDataV3AndMore();
    };
    DetailTableDuplCheckResultsController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableDuplCheckResultsController.prototype.checkTableErrors = function () {
        var errors = [];
        if (this.tableBackendErrors) {
            errors = this.tableBackendErrors;
        }
        var tableRowErrors = this.getTableRowErrors();
        if (tableRowErrors) {
            errors.push(this.getTableRowErrors());
        }
        if (errors && errors.length > 0) {
            this.tableConsolidatedErrors = errors.join(', ');
        }
        else {
            this.tableConsolidatedErrors = undefined;
        }
    };
    DetailTableDuplCheckResultsController.prototype.getTableRowErrors = function () {
        if (!(this.topic.topic.version >= this.OPP_VERSION_4 && this.isDupEditButtonEnabled()) ||
            (this.topic.topic.version < this.OPP_VERSION_4 && !this.isDupEditButtonEnabledVersion3AndLess())) {
            return;
        }
        if (!this.tableRows || !this.tableRows.length) {
            return;
        }
        var errorRows = [];
        for (var i = 0; i < this.tableRows.length; i++) {
            if (!this.isRowCompleted(i)) {
                errorRows.push(i + 1);
            }
        }
        if (errorRows && errorRows.length > 0) {
            return errorRows.length === 1 ?
                "Row " + errorRows[0] + " has missing values" :
                "Rows " + errorRows.join(', ') + " have missing values";
        }
        return undefined;
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompleted = function (key) {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return this.isRowCompletedV5(key);
        }
        else if (this.topic.topic.version >= this.OPP_VERSION_4) {
            return this.isRowCompletedV4(key);
        }
        else {
            return this.isRowCompletedV3(key);
        }
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompletedV5 = function (key) {
        //return !(!_.get(this, `stateList[${key}].comments`) ||
        return _.get(this, "stateList[" + key + "].ssaDecision.value") &&
            _.get(this, "stateList[" + key + "].eiDecision.value");
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompletedV4 = function (key) {
        //return !(!_.get(this, `stateList[${key}].comments`) ||
        return _.get(this, "stateList[" + key + "].ssaDecision.value") &&
            _.get(this, "stateList[" + key + "].eiDecision.value") &&
            _.get(this, "stateList[" + key + "].sbDecision.value");
    };
    DetailTableDuplCheckResultsController.prototype.isRowCompletedV3 = function (key) {
        //return !(!_.get(this, `stateList[${key}].comments`) ||
        return _.get(this, "stateList[" + key + "].cvrDecision.value") &&
            _.get(this, "stateList[" + key + "].ibmDecision.value") &&
            _.get(this, "stateList[" + key + "].sbDecision.value");
    };
    DetailTableDuplCheckResultsController.prototype.getDuplicateCheckResultsDataV3AndMore = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id
                },
                function: 'getDuplicateCheckResultsDataV3AndMore',
                script: '/detail/eligibility/duplicate/index',
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckResultsController.prototype.checkIfRowFails = function () {
        var _this = this;
        this.duplicateCheckResults = _.get(this.topic.topic, "eligibility.duplicateCheckResults", false);
        this.isDupExistInCloudant = !!this.duplicateCheckResults;
        this.stateList = this.tableRows.map(function (row, index) {
            if (_this.duplicateCheckResults) {
                return _this.duplicateCheckResults[index];
            }
            var obj = _this.isVersion4AndMore ?
                {
                    comments: '',
                    eiDecision: { isManualReview: false, value: row.eiDupFound },
                    isFinal: false,
                    level2Label: row.level2Label || row.gbt20ID,
                    sbDecision: { isManualReview: false, value: row.sbDupFound },
                    solutionId: row.dealRegProductGroupID || row.solutionId,
                    ssaDecision: { isManualReview: false, value: row.ssaDupFound }
                } :
                {
                    comments: '',
                    cvrDecision: { isManualReview: false, value: row.cvrDupFound },
                    ibmDecision: { isManualReview: false, value: row.ibmDuplicateFound },
                    isFinal: false,
                    level2Label: row.level2Label || row.gbt20ID,
                    sbDecision: { isManualReview: false, value: row.sbDupFound },
                    solutionId: row.dealRegProductGroupID || row.solutionId
                };
            if (row.cvrDupFound === 'Manual Review') {
                obj.cvrDecision = Object.assign(obj.cvrDecision, { value: '', isManualReview: true });
            }
            if (row.sbDupFound === 'Manual Review') {
                obj.sbDecision = Object.assign(obj.sbDecision, { value: '', isManualReview: true });
            }
            if (row.ibmDuplicateFound === 'Manual Review') {
                obj.ibmDecision = Object.assign(obj.ibmDecision, { value: '', isManualReview: true });
            }
            if (row.eiDupFound === 'Manual Review') {
                obj.eiDecision = Object.assign(obj.eiDecision, { value: '', isManualReview: true });
            }
            if (row.ssaDupFound === 'Manual Review') {
                obj.ssaDecision = Object.assign(obj.ssaDecision, { value: '', isManualReview: true });
            }
            return obj;
        });
    };
    DetailTableDuplCheckResultsController.prototype.edit = function () {
        this.stateListCopy = _.cloneDeep(this.stateList);
        this.changeTableEditMode(true);
    };
    DetailTableDuplCheckResultsController.prototype.cancel = function () {
        this.stateList = this.stateListCopy;
        this.changeTableEditMode(false);
    };
    DetailTableDuplCheckResultsController.prototype.save = function () {
        var updatedTable = [];
        for (var i = 0; i < this.tableRows.length; i++) {
            var row = this.prepareToUpload(i);
            updatedTable.push(row);
        }
        var updateData = {
            isBpAuthOrDupCheckResult: true,
            opportunityId: this.topic.topic._id.substring(4),
            table: updatedTable
        };
        this.uploadResults({ "duplicateCheckResults": this.stateListObj }, updateData);
        this.changeTableEditMode(false);
    };
    DetailTableDuplCheckResultsController.prototype.changeTableEditMode = function (isEdit) {
        this.isTableEditMode = isEdit;
        this.checkTableErrors();
    };
    DetailTableDuplCheckResultsController.prototype.isCvrDupEditable = function (value, key) {
        return (value.cvrDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].cvrDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isSsaDupEditable = function (value, key) {
        return (value.ssaDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].ssaDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isEiDupEditable = function (value, key) {
        return (value.eiDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].eiDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isSbDupEditable = function (value, key) {
        return (value.sbDupFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].sbDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isIbmDupEditable = function (value, key) {
        return (value.ibmDuplicateFound === 'Manual Review' && !this.isDupExistInCloudant) ||
            (this.isDupExistInCloudant && this.stateList[key].ibmDecision.isManualReview);
    };
    DetailTableDuplCheckResultsController.prototype.isDupEditButtonEnabledVersion3AndLess = function () {
        if (!this.topic.editableComponents[this.comp] || this.topic.editableComponents[this.comp].socket) {
            return false;
        }
        if (!this.tableRows || !this.tableRows.length) {
            return false;
        }
        for (var i = 0; i < this.tableRows.length; i++) {
            if (this.isCvrDupEditable(this.tableRows[i], i) || this.isSbDupEditable(this.tableRows[i], i) || this.isIbmDupEditable(this.tableRows[i], i)) {
                return true;
            }
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.isRowEditableVersion3AndLess = function (key) {
        if (this.isCvrDupEditable(this.tableRows[key], key) || this.isSbDupEditable(this.tableRows[key], key) || this.isIbmDupEditable(this.tableRows[key], key)) {
            return true;
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.isDupEditButtonEnabled = function () {
        if (!this.topic.editableComponents[this.comp] || this.topic.editableComponents[this.comp].socket) {
            return false;
        }
        if (!this.tableRows || !this.tableRows.length) {
            return false;
        }
        for (var i = 0; i < this.tableRows.length; i++) {
            if (this.isSsaDupEditable(this.tableRows[i], i) || this.isEiDupEditable(this.tableRows[i], i) || this.isSbDupEditable(this.tableRows[i], i)) {
                return true;
            }
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.isRowEditable = function (key) {
        if (this.isSsaDupEditable(this.tableRows[key], key) || this.isEiDupEditable(this.tableRows[key], key) || this.isSbDupEditable(this.tableRows[key], key)) {
            return true;
        }
        return false;
    };
    DetailTableDuplCheckResultsController.prototype.uploadResults = function (itemToUpdate, table) {
        var data = {
            data: (_a = {},
                _a['eligibility'] = {
                    add: true,
                    data: itemToUpdate
                },
                _a
            ),
            id: this.topic.topic._id,
            type: ['eligibility']
        };
        this.topic.updateServerTopic('couchUpdate', data, true, table);
        var _a;
    };
    /**
     * Update BP Duplicate Found? and IBM Duplicate Found? in Deal Registration Product Group table
     * @param {any} itemToUpdate
     */
    DetailTableDuplCheckResultsController.prototype.updateDealRegProductGroupData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id.substring(4)
                },
                function: 'getDealRegProductGroupData',
                script: '/detail/eligibility/drpgResult/index',
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckResultsController.prototype.prepareToUpload = function (key) {
        // Return object of objects with index and change flag to true for current stateList
        this.stateListObj = this.stateList.reduce(function (obj, el, index) {
            // if (index === key) {
            //     el.isFinal = true;
            // }
            return Object.assign(obj, (_a = {}, _a[index] = el, _a));
            var _a;
        }, {});
        var check = {
            EI: this.isVersion4AndMore ? this.stateList[key].eiDecision.value : undefined,
            SB: this.stateList[key].sbDecision.value,
            SC: this.isVersion4AndMore ? undefined : this.stateList[key].ibmDecision.value,
            SSA: this.isVersion4AndMore ? this.stateList[key].ssaDecision.value : this.stateList[key].cvrDecision.value,
            level2Label: this.stateList[key].level2Label,
            solutionId: this.stateList[key].solutionId
        };
        return check;
        //        this.uploadResults({ "duplicateCheckResults": stateListObj }, checks);
    };
    DetailTableDuplCheckResultsController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs', 'Dialog', '_'];
    return DetailTableDuplCheckResultsController;
}());
var DetailTableDuplCheckResultsComponent = (function () {
    function DetailTableDuplCheckResultsComponent() {
        this.templateUrl = 'detail-table-duplcheck-results.html';
        this.controllerAs = 'vm';
        this.bindings = dupBind;
        this.controller = DetailTableDuplCheckResultsController;
    }
    return DetailTableDuplCheckResultsComponent;
}());
angular
    .module('application')
    .component('detailTableDuplCheckResults', new DetailTableDuplCheckResultsComponent());

//# sourceMappingURL=detail.table.duplcheck.results.component.js.map
